import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="50" height="50" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0)">
            <path d="M11.4107 8.03532L4.66522 14.7785C4.36924 15.0737 3.88969 15.0737 3.59296 14.7785C3.29697 14.4833 3.29697 14.0037 3.59296 13.7085L9.80335 7.50034L3.59371 1.29219C3.29772 0.996956 3.29772 0.517413 3.59371 0.221428C3.88969 -0.0738094 4.36998 -0.0738094 4.66597 0.221428L11.4114 6.96456C11.7028 7.25674 11.7028 7.74382 11.4107 8.03532Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="15" height="15" fill="white" transform="matrix(-1 0 0 1 15 0)"/>
            </clipPath>
        </defs>
    </svg>
)
